
import InputModelsAutocomplete from '../InputModelsAutocomplete/InputModelsAutocomplete.vue'

import translations from './ComparisonForm.translations'

export default {
  components: { InputModelsAutocomplete },

  props: {
    autocompleteConfig: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    modelsNames: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      values: this.modelsNames || [],
    }
  },

  computed: {
    translations: () => translations,
  },

  watch: {
    modelsNames: {
      handler(newModelsNames) {
        if (newModelsNames) {
          this.values = newModelsNames
        }
      },
    },
  },

  methods: {
    handleModelSelection({ model, inputId }) {
      this.$emit('model-selected', { model, inputId })
    },
  },
}
